/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./text-item.component";
var styles_TextItemComponent = [];
var RenderType_TextItemComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_TextItemComponent, data: {} });
export { RenderType_TextItemComponent as RenderType_TextItemComponent };
export function View_TextItemComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["\n  text-item works!\n"])), (_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_TextItemComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-text-item", [], null, null, null, View_TextItemComponent_0, RenderType_TextItemComponent)), i0.ɵdid(1, 4308992, null, 0, i1.TextItemComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var TextItemComponentNgFactory = i0.ɵccf("app-text-item", i1.TextItemComponent, View_TextItemComponent_Host_0, {}, {}, []);
export { TextItemComponentNgFactory as TextItemComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/reports/text-item/text-item.component.ngfactory.js.pre-build-optimizer.js